var staticEncodeURIComponent = encodeURIComponent

module.exports = staticEncodeURIComponent



//////////////////
// WEBPACK FOOTER
// ./~/xe-utils/staticEncodeURIComponent.js
// module id = SJw3
// module chunks = 137